import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { splitFilename } from 'src/app/helpers/file-helpers';
import { CaseModel } from 'src/app/models/case.model';
import { DocumentModel } from 'src/app/models/document.model';
import { DocumentDataService } from 'src/app/services/document-data.service';
import { FileMenuActions, OpenMenuItems } from 'src/app/models/file-menu.model';
import { ClientCaseDocumentsComponent } from '../open-document/client-case-documents/client-case-documents.component';
import { FileModel, FolderModel } from 'src/app/models/folder.model';
import { PreferencesService } from 'src/app/services/preferences.service';
import { take } from 'rxjs';
import { DialogService } from 'src/app/services/dialog.service';
import { BrowseDocumentsComponent } from '../open-document/browse-documents/browse-documents.component';

@Component({
  selector: 'tx-save-as',
  templateUrl: './save-as.component.html',
  styleUrls: ['./save-as.component.scss'],
})
export class SaveAsComponent implements OnInit, OnChanges {
  @Input() isPdf: boolean = false;
  @Input() document: DocumentModel;
  @Input() existingDocument: string | undefined = '';
  @ViewChild('clientCaseDocuments') clientCaseDocumentsComponent!: ClientCaseDocumentsComponent;
  @ViewChild('browseDocuments') browseDocumentsComponent!: BrowseDocumentsComponent;
  public preselectedContactId: string;
  public preselectedCaseId: string;
  public selectedCaseId: CaseModel | undefined;
  public currentFolder: FolderModel | undefined;
  public currentDocumentFolderPath: string = '';
  openMenuItems = OpenMenuItems;
  fileMenuActions = FileMenuActions;
  activeComponent: string;

  public filename: string;
  public caseSelected: boolean;
  public documents: DocumentModel[] = [];
  public defaultFileType: string = '.docx';
  @Output() saveAs: EventEmitter<DocumentModel> = new EventEmitter();
  @Output() save: EventEmitter<DocumentModel> = new EventEmitter();
  @Output() download: EventEmitter<boolean> = new EventEmitter();
  @Output() openDocument: EventEmitter<DocumentModel | null> = new EventEmitter();
  @Output() openInNewTab: EventEmitter<DocumentModel | null> = new EventEmitter();
  @Output() uploadDocument: EventEmitter<DocumentModel> = new EventEmitter();

  constructor(
    private documentDataService: DocumentDataService,
    private preferencesService: PreferencesService,
    private dialogService: DialogService
  ) {
    // add ToastService to constructor
    this.filename = '';
    this.document = {
      isActiveDocument: true,
      saveAsPdf: false,
      answersChanged: false,
      openInAnotherSession: false,
      pdfAnswersChanged: false,
      txdocsAnswersChanged: false,
    };
    this.caseSelected = false;
    this.preselectedCaseId = this.documentDataService.getCasId().trim();
    this.preselectedContactId = this.documentDataService.getCtcId().trim();
    this.activeComponent = this.preselectedCaseId ? this.openMenuItems.ClientCase : this.openMenuItems.Browse;
  }

  ngOnInit(): void {
    console.log('Init:' + this.existingDocument, this.document);
    if (!this.document.filename) {
      this.filename = 'Untitled Document' + this.defaultFileType;
    } else {
      this.filename = this.document.filename;
    }
    let test: CaseModel = {
      description: this.document.casDescription ?? '',
      folder: this.document.folder ?? '',
      ctcFirstName: this.document.ctcFirstName ?? '',
      ctcLastName: this.document.ctcLastName ?? '',
      casID: this.document.casID ?? '',
      ctcId: this.document.ctcID ?? '',
    };
    this.selectedCaseId = test;
    if (this.preselectedCaseId) {
      this.caseSelected = true;
    }
    if (!this.isPdf) {
      this.getDefaultFileType();
    } else {
      this.defaultFileType = '.pdf';
    }
    this.currentDocumentFolderPath = this.getDocumentFolderPath();
  }
  setCurrentFolder(folder: FolderModel) {
    this.currentFolder = folder;
  }

  changeComponent(component: string) {
    this.activeComponent = component;
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes['document'] && changes['document'].currentValue) {
      this.filename = changes['document'].currentValue.filename;
    }
  }

  onSaveClicked() {
    if (
      this.filename.toLowerCase() === this.document.filename?.toLowerCase() &&
      this.currentDocumentFolderPath === this.currentFolder?.path
    ) {
      this.dialogService.confirm({
        title: 'Save document',
        message: 'This filename is the same as the current open document. Would you like to save the current document?',
        confirmCallback: () => this.save.emit(),
        rejectCallback: () => {},
      });
    } else {
      let theSplitFilename = splitFilename(this.filename);
      if (theSplitFilename.extension === '') {
        this.filename += this.defaultFileType;
      }
      let document = { ...this.document };
      if (this.activeComponent == this.openMenuItems.ClientCase) {
        document.filename = this.filename;
        document.pathname = document.folder?.trim() + '\\' + document.filename;
        this.caseSelected = false;
      } else if (this.activeComponent == this.openMenuItems.Browse) {
        document.filename = this.filename;
        document.folder = this.currentFolder?.path ?? '';
        if (document.folder === '') {
          document.folder = '\\';
        }
        document.pathname = document.folder.trim() + '\\' + document.filename;
        document.casDescription = '';
        document.casID = '';
        document.ctcID = '';
        document.ctcFirstName = '';
        document.ctcLastName = '';
      }
      this.saveAs.emit(document);
    }
  }

  downloadDocument(downloadAsPdf: boolean) {
    this.download.emit(downloadAsPdf);
    //this.onSaveClicked();
  }

  onCaseSelected(cas: CaseModel) {
    this.document.casID = cas.casID;
    this.document.casDescription = cas.description;
    this.document.ctcFirstName = cas.ctcFirstName;
    this.document.ctcLastName = cas.ctcLastName;
    this.document.folder = cas.folder;
    this.caseSelected = true;
    this.selectedCaseId = cas;
  }
  documentSelected(event: DocumentModel | null) {
    if (event === null) {
    } else {
      this.filename = event.filename ?? this.filename;
    }
    console.log(event);
  }
  //allow method to return true for the current "this.document" as well to prevent ghost documents from making to the menu list and database
  isFilenameDuplicated(filename: string = this.filename) {
    if (this.clientCaseDocumentsComponent && this.clientCaseDocumentsComponent.documents) {
      return this.clientCaseDocumentsComponent.documents.some(
        (document: DocumentModel) =>
          document.filename?.toLowerCase() === filename.toLowerCase()
          //&& this.document.filename?.toLowerCase() !== filename.toLowerCase()
      );
    } else if (this.browseDocumentsComponent) {
      return this.browseDocumentsComponent.currentFolder?.files?.some((document: FileModel) => {
        return (
          document.name?.toLowerCase() === filename.toLowerCase() 
          //&& this.document.filename?.toLowerCase() !== filename.toLowerCase()
        );
      });
    }
    return false;
  }

  isFilenameEmpty() {
    return this.filename == null || this.filename === '' || this.filename.indexOf('.') === 0;
  }

  isCaseNotSelected() {
    return this.activeComponent === this.openMenuItems.ClientCase && !this.caseSelected;
  }

  getNextFileName() {
    let nextFileName = this.filename;
    let index = 1;
    // Break out the filename extension from file
    const extensionIndex = this.filename.lastIndexOf('.');
    const filename = this.filename.substring(0, extensionIndex);
    const extension = this.filename.substring(extensionIndex);
    const regex = / - (\d+)$/; // ends with - <number>
    const match = filename.match(regex);
    if (match) {
      index = parseInt(match[1]) + 1;
      nextFileName = `${filename.replace(regex, '')} - ${index}${extension}`;
    } else {
      while (this.isFilenameDuplicated(nextFileName)) {
        nextFileName = `${filename} - ${++index}${extension}`;
      }
    }
    return nextFileName;
  }

  isDocumentAssembledWithoutCase() {
    return this.document.dcmID?.trim() && !this.document.casID?.trim();
  }

  private getDefaultFileType() {
    this.preferencesService
      .getDocumentFormat()
      .pipe(take(1))
      .subscribe((res) => {
        this.defaultFileType = res;
      });
  }

  private getDocumentFolderPath() {
    // should return empty string if the current document is a case document
    if (
      this.document.pathname &&
      this.document.filename &&
      (!this.document.casID || this.document.casID.trim() === '')
    ) {
      const folderPath = this.document.pathname.replace(`\\${this.document.filename}`, '');

      if (folderPath !== '\\') {
        // '\\' would be the value of folderPath in case of the root folder. We want to return '' in that case
        return folderPath;
      }
    }

    return '';
  }
}
